import React from "react";
import {
  isRouteErrorResponse,
  useRouteError,
  useNavigate,
} from "react-router-dom";
import styles from "./error-page.module.scss";
import { PATH } from "../../router/path";

export const ErrorPage = () => {
  const error = useRouteError();
  const navigate = useNavigate();
  let errorMessage: string;

  const back = () => {
    navigate(-1);
  };

  if (isRouteErrorResponse(error)) {
    errorMessage = error.statusText;
  } else if (error instanceof Error) {
    errorMessage = error.message;
  } else if (typeof error === "string") {
    errorMessage = error;
  } else {
    console.error(error);
    errorMessage = "Unknown error";
  }
  return (
    <div className={styles.main}>
      <div className={styles.container}>
        {isRouteErrorResponse(error) && error.status === 404 ? (
          <h1 className={styles.title}>404</h1>
        ) : (
          <h1 className={styles.title}>Непредвиденная ошибка</h1>
        )}

        <p>
          <i className={styles.message}>{errorMessage}</i>
        </p>
        <button className={styles.button} onClick={back}>
          Назад
        </button>
      </div>
    </div>
  );
};
